import i18next from 'i18next'
import XHR from 'i18next-xhr-backend'

let instance = null

export default class I18n {
  constructor () {
    if (instance != null) {
      this.i18next = i18next
      return
    }

    i18next
      .use(XHR)
      .init({
        debug: process.env.NODE_ENV !== 'production',
        // debug: false,

        load: 'currentOnly',

        initImmediate: false,

        lng: 'nl-NL',

        fallbackLng: 'en-US',

        preload: ['nl-NL'],

        defaultNS: 'common',

        fallbackNS: 'common',

        ns: ['common'],

        joinArrays: ' ',

        backend: {
          loadPath: '{{lng}}/{{ns}}',
          parse: (data) => data,
          jsonIndent: 2,
          ajax: (url, options, callback, data) => {
            try {
              callback(require(`@/locales/${url}.json`), { status: '200' })
            } catch (e) {
              callback(null, { status: '404' })
            }
          }
        }
      })
    this.i18next = i18next
  }

  static getInstance () {
    if (instance == null) {
      instance = new I18n()
    }
    return instance
  }

  t (...args) {
    return this.translate(...args)
  }

  getFixedNamespaceT (namespace) {
    return this.i18next.getFixedT(null, namespace)
  }

  translate (key, options, defaults = {}) {
    return this.i18next.t(key, {
      ...defaults,
      ...options
    })
  }

  translateHtml (key) {
    return require(`@/locales/nl-NL/${key}.html`)
  }
}




// WEBPACK FOOTER //
// ./src/services/i18n/i18n.js